import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { reportsState } from './reportsState';
import { RootState } from 'store/store';

import { Reports } from 'app/types/reports';
import { DriverName } from 'app/services/api/models/DriverName';

export const hosReportsSlice = createSlice({
  name: 'hosReports',
  initialState: reportsState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setDrivers(state, action: PayloadAction<DriverName[]>) {
      state.drivers = action.payload;
    },
    setReports(state, action: PayloadAction<Reports[]>) {
      state.reports = action.payload;
    },
    setHiddenReports(state, action: PayloadAction<string[]>) {
      state.hiddenReports = action.payload;
    },
    setRequestPendingTo(state, action: PayloadAction<boolean>) {
      state.isRequestPending = action.payload;
    },
  },
});

/* ------- ACTION CREATORS ------- */
export const { actions: hosReportsActions } = hosReportsSlice;

/* ------- STATE SELECTORS ------- */
export const selectHosReports = (state: RootState) => state.hosReports;

export default hosReportsSlice.reducer;
